export const pageSearch = {
 
}

export default {
  'reward_number': {
    title: '奖励编号',
    type: 'input',
  },
  'reward_id': {
    title: '项目编号',
    type: 'input',
  },
  'reward_name': {
    title: '项目类型',
    type: 'input',
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'customer_name': {
    title: '客户名称',
    type: 'input',
  },
  'amount': {
    title: '金额（元）',
  },
  'product_id': {
    title: '产品编码',
  },
  'product_name': {
    title: '产品名称',
  },
  'start_date': {
    title: '有效期起',
  },
  'end_date': {
    title: '有效期止',
  },
  'object_id': {
    title: '订单号',
    type: 'input',
  },
  'order_customer': {
    title: '订单客户编码',
    type: 'input',
  },
  'order_customer_name': {
    title: '订单客户名称',
  },
  'zzfld00002i': {
    title: '订单折扣金额',
  },
}



// WEBPACK FOOTER //
// ./src/views/reward-policy/config/rewardUserData.js